import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = true;

export const showSiteFavOnlySlice = createSlice({
  name: 'showSiteFavOnly',
  initialState,
  reducers: {
    toggleChecked: (state, action: PayloadAction<boolean>) => {
      return action.payload;
    }
  }
});

export const { toggleChecked } = showSiteFavOnlySlice.actions;
export default showSiteFavOnlySlice.reducer;
